import UseContext from 'hooks/useContext';
import { useCallback, useEffect, useRef } from 'react';

// Something changed in a panel or a form, and the lists that show it reload:
// the change travels in `modalDataReturn` as `{ type, at }`, as the invoice
// reminders do (useInvoiceReminderChanged).

export const useNotifyChange = (type) => {
  const { setModalDataReturn } = UseContext();
  return useCallback(() => setModalDataReturn({ type, at: Date.now() }), [setModalDataReturn, type]);
};

export const useOnChange = (type, onChanged) => {
  const { modalDataReturn } = UseContext();
  const lastSeen = useRef(modalDataReturn);
  const callback = useRef(onChanged);
  callback.current = onChanged;

  useEffect(() => {
    if (lastSeen.current === modalDataReturn) return;
    lastSeen.current = modalDataReturn;
    if (modalDataReturn?.type !== type) return;
    callback.current();
  }, [modalDataReturn, type]);
};
